"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PeerConnection = _interopRequireDefault(require("./PeerConnection"));

var _cache = _interopRequireDefault(require("../util/cache"));

var Log = _interopRequireWildcard(require("../util/Log"));

var DataSync = _interopRequireWildcard(require("../util/DataSync"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var getShortStackId = function getShortStackId(id1, id2) {
  return id1.localeCompare(id2, 'en-us') > 0 ? "".concat(id1, "-").concat(id2) : "".concat(id2, "-").concat(id1);
};
/* eslint-disable no-bitwise */


var hashCode = function hashCode(str) {
  return str.split('').reduce(function (prevHash, currVal) {
    return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
  }, 0);
};
/* eslint-enable no-bitwise */


var getStackId = function getStackId(deviceId1, deviceId2) {
  var shortstackId = getShortStackId(deviceId1, deviceId2);
  var hash = "".concat(hashCode(shortstackId));
  var length = hash.length; // eslint-disable-line

  var id1 = hash.substring(length - 3, length);
  var id2 = hash.substring(length - 6, length - 3);
  return "".concat(id1, "/").concat(id2, "/").concat(shortstackId);
};
/**
 * @access protected
 */


var PeerConnectionManager =
/*#__PURE__*/
function () {
  /**
   * Constructor
   * @access protected
   */
  function PeerConnectionManager() {
    _classCallCheck(this, PeerConnectionManager);

    /**
     * WebRTC stacks
     * @type {{*: {*: PeerConnection}}}
     */
    this.stacks = {};
  }
  /**
   * Get a PeerConnection object for a specific stream
   * @param {Local|Remote} stream
   * @param {Remote|{to: string, device:string}} remote
   * @param {boolean} publish
   * @return {*}
   */


  _createClass(PeerConnectionManager, [{
    key: "getPeerConnection",
    value: function getPeerConnection(stream, remote, publish) {
      var _this = this;

      if (!_cache.default.user) {
        return Promise.reject(new Error('Only an authenticated user can get a PeerConnection\'s object.'));
      }

      var stackId = getStackId(remote.device, _cache.default.device);

      if (this.stacks[stackId] && this.stacks[stackId][stream.uid]) {
        return Promise.resolve(this.stacks[stackId][stream.uid]);
      }

      if (!this.stacks[stackId]) {
        this.stacks[stackId] = {};
      }

      var userId = _cache.default.user.uid.split('/');

      var shortUserId = userId[2];
      var shortRemoteTo;
      var shortRemoteFrom;

      if (remote.to) {
        var remoteTo = remote.to.split('/');
        shortRemoteTo = remoteTo[2]; // eslint-disable-line prefer-destructuring
      } else {
        var remoteFrom = remote.from.split('/');
        shortRemoteFrom = remoteFrom[2]; // eslint-disable-line prefer-destructuring
      }

      var users = {}; // users[cache.user.uid] = true;

      users[shortUserId] = true; // users[remote.from || remote.to] = true;

      users[shortRemoteFrom || shortRemoteTo] = true;
      return DataSync.update("_/webrtc/".concat(stackId), users).then(function () {
        return new _PeerConnection.default(stackId, stream.uid, remote, publish);
      }).then(function (pc) {
        Log.d('PeerConnectionManager~getPeerConnection', {
          stackId: stackId,
          streamId: stream.uid,
          pc: pc
        });
        _this.stacks[stackId][stream.uid] = pc;
        return pc;
      }).catch(Log.r('PeerConnectionManager~getPeerConnection'));
    }
    /**
     * Create offer for a stream to a subscriber
     * @param {Local} localStream
     * @param {object} subscriber
     * @param {array} errorCallbacks
     * @return {Promise.<PeerConnection>}
     */

  }, {
    key: "offer",
    value: function offer(localStream, subscriber, errorCallbacks) {
      Log.d('PeerConnectionManager~offer', {
        localStream: localStream,
        subscriber: subscriber
      });
      return this.getPeerConnection(localStream, subscriber, true).then(function (pc) {
        return pc.offer(localStream.media, errorCallbacks);
      });
    }
    /**
     * Answer to the offer from the publisher
     * @param {Remote} remoteStream
     * @param {Element} htmlElement
     * @param {array} errorCallbacks
     * @return {*|Promise.<PeerConnection>}
     */

  }, {
    key: "answer",
    value: function answer(remoteStream, htmlElement) {
      var errorCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      Log.d('PeerConnectionManager~answer', {
        remoteStream: remoteStream,
        htmlElement: htmlElement
      });
      return this.getPeerConnection(remoteStream, remoteStream, false).then(function (pc) {
        return pc.answer(htmlElement, errorCallbacks);
      });
    }
    /**
     * Close a PeerConnection
     * @param streamId
     * @param remoteDevice
     * @return {*}
     */

  }, {
    key: "close",
    value: function close(streamId, remoteDevice) {
      var stackId = getStackId(remoteDevice, _cache.default.device);
      var pc = this.stacks[stackId] ? this.stacks[stackId][streamId] : null;

      if (pc) {
        pc.close();
        DataSync.remove("_/webrtc/".concat(stackId));
        this.stacks[stackId][streamId] = null;
        delete this.stacks[stackId][streamId];
        return pc;
      }

      return false;
    }
  }]);

  return PeerConnectionManager;
}();

exports.default = PeerConnectionManager;